/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodPrice } from './paymentMethodPrice';
import { OfferImage } from './offerImage';
import { PaymentMethodExternal } from './paymentMethodExternal';
import { PaymentMethodInternal } from './paymentMethodInternal';
import { PaymentMethodApple } from './paymentMethodApple';
import { PaymentMethodGoogle } from './paymentMethodGoogle';


/**
 * @type GetOfferPaymentMethods200ResponseDataItemsInnerObject
 * @export
 */
export type GetOfferPaymentMethods200ResponseDataItemsInnerObject = PaymentMethodApple | PaymentMethodExternal | PaymentMethodGoogle | PaymentMethodInternal;

